export default function CEOMessage() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">대표 인사말</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-500 to-amber-600 mx-auto"></div>
        </div>

        <div className="grid lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-amber-500/20 to-slate-900/20 rounded-2xl blur-xl"></div>
              <img
                src="https://public.readdy.ai/ai/img_res/657819c90dd48c5d2fabbe7d11249ab5.jpg"
                alt="대표이사 홍재기"
                className="relative w-full h-full object-cover rounded-2xl shadow-2xl"
              />
            </div>
          </div>

          <div className="lg:col-span-3 space-y-6">
            <div className="bg-gradient-to-br from-slate-50 to-amber-50 p-8 rounded-2xl border border-amber-200">
              <p className="text-lg leading-relaxed text-slate-700 mb-6">
                안녕하십니까. 주식회사 재기목형 대표이사 <strong className="text-slate-900">홍재기</strong>입니다.
              </p>
              <p className="text-lg leading-relaxed text-slate-700 mb-6">
                저희 재기목형은 1990년대 초반부터 서울 을지로 방산시장에서 목형 제작 외길을 걸어온 전문 기업입니다. 30여 년간 쌓아온 노하우와 기술력으로 고객 여러분께 최상의 제품을 제공하기 위해 최선을 다하고 있습니다.
              </p>
              <p className="text-lg leading-relaxed text-slate-700 mb-6">
                장기근속 직원들의 숙련된 기술과 전문성은 저희의 가장 큰 자산입니다. 이를 바탕으로 특수목형 제작 및 개발에 힘쓰고 있으며, 전국에 거래처를 두고 업계 최고의 제품을 생산하고 있습니다.
              </p>
              <p className="text-lg leading-relaxed text-slate-700 mb-6">
                또한 레이저 가공 전문 브랜드 '뉴테크'를 통해 전통적인 목형 제작 기술과 최신 레이저 가공 기술을 결합하여, 고객 여러분께 더욱 다양하고 정밀한 솔루션을 제공하고 있습니다.
              </p>
              <p className="text-lg leading-relaxed text-slate-700">
                앞으로도 변함없는 품질과 신뢰로 고객 여러분과 함께 성장하는 재기목형이 되겠습니다. 감사합니다.
              </p>
            </div>

            <div className="flex items-center justify-end gap-4 pt-4">
              <div className="text-right">
                <div className="text-2xl font-bold text-slate-900">홍재기</div>
                <div className="text-sm text-slate-600">주식회사 재기목형 대표이사</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
